import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MessageCreateIntercomPage } from './message-create-intercom';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		MessageCreateIntercomPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(MessageCreateIntercomPage),
	],
})
export class MessageCreateIntercomPageModule {}



// WEBPACK FOOTER //
// ./src/pages/message-create-intercom/message-create-intercom.module.ts